<template>
    <div class="screen-center-wrapper">

        <div v-if="showOverlay" class="overlay">
            <div class="progress-container">
                <h2 style="color: white;">Generating Your Birth Chart Interpretation...</h2>
                <p class="status-text">{{ currentStatus }}</p>
                <div class="progress-bar">
                    <div class="progress-fill" :style="{ width: progressWidth }">
                    </div>
                </div>
            </div>
        </div>	

        <div class="form-container">
        <!-- Row 1: Logo -->
        <h2 class="main-title">Ancient Wisdom. <br/>Modern Self-Discovery.</h2>

        <!-- Row 2: Label Chart Title -->
        <div class="form-row">
            <label for="chartTitle">
              <font-awesome-icon :icon="['far', 'user']" size="lg" class="fontAwesomeIcon" />&nbsp;&nbsp;Chart Title
            </label>
        </div>
    
        <!-- Row 3: Input for Chart Title -->
        <div class="form-row">
            <input
                type="text"
                minlength="2"
                maxlength="45"
                size="25"
                placeholder="Chart Title / Name / Initials"
                v-model="criteria.client"
              />
        </div>
    
        <!-- Row 4: Label Date of Birth -->
        <div class="form-row">
            <label>
              <font-awesome-icon :icon="['fas', 'calendar-days']" size="lg" class="fontAwesomeIcon" />&nbsp;&nbsp;Date of Birth
            </label>
        </div>
    
        <!-- Row 5: DOB Dropdowns -->
        <div class="form-row dropdown-group">
            
            <select v-model="criteria.month" @change="updateCriteriaDate">
                <option disabled value="">Month</option>
                <option v-for="m in 12" :value="m" :key="m">
                  {{ new Date(0, m - 1).toLocaleString('default', { month: 'long' }) }}
                </option>
            </select>

            <select v-model="criteria.day" @change="updateCriteriaDate">
                <option disabled value="">Day</option>
                <option v-for="d in 31" :value="d" :key="d">{{ d }}</option>
            </select>
            
            <select v-model="criteria.year" @change="updateCriteriaDate">
                <option disabled value="">Year</option>
                <option v-for="year in years" :value="year" :key="year">
                  {{ year }}
                </option>
              </select>
        </div>
    
        <!-- Row 6: Label Time of Birth -->
        <div class="form-row">
            <label>
              <font-awesome-icon :icon="['far', 'clock']" size="lg" class="fontAwesomeIcon" />&nbsp;&nbsp;Time of Birth
            </label>
        </div>
    
        <!-- Row 7: Time Dropdowns -->
        <div class="form-row dropdown-group">
            <select v-model="criteria.hour" @change="updateCriteriaDate">
                <option disabled value="">Hour</option>
                <option v-for="h in 24" :value="h - 1" :key="h">
                  {{ h - 1 }} -
                  {{ new Date(0, 0, 0, h - 1).toLocaleTimeString([], { hour: '2-digit', hour12: true }) }}
                </option>
            </select>
            <select v-model="criteria.minute" @change="updateCriteriaDate">
                <option disabled value="">Min</option>
                <option v-for="m in 60" :value="m - 1" :key="'min' + m">
                  {{ (m - 1).toString().padStart(2, '0') }}
                </option>
            </select>
              <select v-model="criteria.second" @change="updateCriteriaDate">
                <option disabled value="">Sec</option>
                <option v-for="s in 60" :value="s - 1" :key="'sec' + s">
                  {{ (s - 1).toString().padStart(2, '0') }}
                </option>
            </select>

        </div>
    
        <!-- Row 8: Label Place of Birth -->
        <div class="form-row">
            <label for="place">
              <font-awesome-icon :icon="['fas', 'location-dot']" size="lg" class="fontAwesomeIcon" />&nbsp;&nbsp;Place of Birth
            </label>
        </div>
    
        <!-- Row 9: Input Place of Birth -->
        <div class="form-row">
            <WorldCitySearch
                :criteria="criteria"
                @selectedWorldCity="setWorldCity"
            />
        </div>
    
        <!-- Row 10: CTA Button -->
        <div class="form-row" style="padding-top: 20px;">
            <button @click="showChart">Generate Report</button>
        </div>
        </div>
    </div>    
  </template>
  
  <script>
  
  import HTTP from "../http-axios.js";
  import ApiBaseUrl from "@/http-api-base-url";
  import { isValidLatitude, isValidLongitude, queryString, criteriaToken } from "../util.js";
  import WorldCitySearch from "./widget-city-search/WorldCitySearch.vue";
  
  export default {
      name: "ChartCriteria",
      components: { WorldCitySearch },
      props: {
		    userSelectedChartStyle : {
			    type: Object
		    }
	    },      
      beforeCreate() {
      },
      data() {
          return {
              criteria: {
                  referrer : "www.vedicastrologyreport.com",
                  client: this.$route.query.client ? this.$route.query.client : localStorage.getItem("ncclient") ? localStorage.getItem("ncclient") : "",
  
                  year: this.$route.query.year ? this.$route.query.year : localStorage.getItem("ncyear") ? Number.parseInt(localStorage.getItem("ncyear")) : new Date().getFullYear(),
                  month: this.$route.query.month ? this.$route.query.month : localStorage.getItem("ncmonth") ? Number.parseInt(localStorage.getItem("ncmonth")) : new Date().getMonth() + 1,
                  day: this.$route.query.day ? this.$route.query.day : localStorage.getItem("ncday") ? Number.parseInt(localStorage.getItem("ncday")) : new Date().getDate(),
  
                  hour: this.$route.query.hour ? this.$route.query.hour : localStorage.getItem("nchour") ? Number.parseInt(localStorage.getItem("nchour")) : new Date().getHours(),
                  minute: this.$route.query.minute ? this.$route.query.minute : localStorage.getItem("ncminute") ? Number.parseInt(localStorage.getItem("ncminute")) : new Date().getMinutes(),
                  second: this.$route.query.second ? this.$route.query.second : localStorage.getItem("ncsecond") ? Number.parseInt(localStorage.getItem("ncsecond")) : 0,
  
                  location: this.$route.query.location ? this.$route.query.location : localStorage.getItem("ncloc") ? localStorage.getItem("ncloc") : "Tiruvannamalai, Tamil Nadu, India",
                  latitude: this.$route.query.latitude ? this.$route.query.latitude : localStorage.getItem("nclat") ? new Number(localStorage.getItem("nclat")) : 12.2253,
                  longitude: this.$route.query.longitude ? this.$route.query.longitude : localStorage.getItem("nclong") ? new Number(localStorage.getItem("nclong")) : 79.0747,
                  timeOffsetMinutes: this.$route.query.timeOffsetMinutes ? this.$route.query.timeOffsetMinutes : localStorage.getItem("nctimeOffsetMinutes") ? Number.parseInt(localStorage.getItem("nctimeOffsetMinutes")) : 330,
                  timeOffset: this.$route.query.timeOffset ? this.$route.query.timeOffset : localStorage.getItem("nctimeOffset") ? new Number(localStorage.getItem("nctimeOffset")) : 5.5,
                  timezone: this.$route.query.timezone ? this.$route.query.timezone : localStorage.getItem("nctz") ? localStorage.getItem("nctz") : "Asia/Kolkata",
  
                  chartStyle: this.$route.query.chartStyle ? this.$route.query.chartStyle : localStorage.getItem("ncchartStyle") ? Number.parseInt(localStorage.getItem("ncchartStyle")) : this.userSelectedChartStyle,
                  ayanamsa: this.$route.query.ayanamsa ? this.$route.query.ayanamsa : localStorage.getItem("ncayanamsa") ? Number.parseInt(localStorage.getItem("ncayanamsa")) : 1,
                  bhavaChartType: this.$route.query.bhavaChartType ? this.$route.query.bhavaChartType : localStorage.getItem("ncbhavaChart") ? Number.parseInt(localStorage.getItem("ncbhavaChart")) : 87,
                  dasaBuktiDaysInYear: this.$route.query.dasaBuktiDaysInYear ? this.$route.query.dasaBuktiDaysInYear : localStorage.getItem("ncddiy") ? Number.parseFloat(localStorage.getItem("ncddiy")) : 365.256,
                  aspectDegreeLimit: this.$route.query.aspectDegreeLimit ? this.$route.query.aspectDegreeLimit : localStorage.getItem("ncadl") ? Number.parseFloat(localStorage.getItem("ncadl")) : 15,
                  conjunctionDegreeLimit: this.$route.query.conjunctionDegreeLimit ? this.$route.query.conjunctionDegreeLimit : localStorage.getItem("nccdl") ? Number.parseFloat(localStorage.getItem("nccdl")) : 20,
                  rahuNode: this.$route.query.rahuNode ? this.$route.query.rahuNode : localStorage.getItem("ncrkn") ? Number.parseInt(localStorage.getItem("ncrkn")) : 10,
                  topocentricPlanets: this.$route.query.topocentricPlanets ? this.$route.query.topocentricPlanets : localStorage.getItem("nctopo") ? Number.parseInt(localStorage.getItem("nctopo")) : 0,
                  nutationRequired: this.$route.query.nutationRequired ? this.$route.query.nutationRequired : localStorage.getItem("ncnutation") ? Number.parseInt(localStorage.getItem("ncnutation")) : 0,
                  hinduSunrise: this.$route.query.hinduSunrise ? this.$route.query.hinduSunrise : localStorage.getItem("ncsunrise") ? Number.parseInt(localStorage.getItem("ncsunrise")) : 1,
                  maandiCalculationMethod: this.$route.query.maandiCalculationMethod ? this.$route.query.maandiCalculationMethod : localStorage.getItem("ncmaandiCalculation") ? Number.parseInt(localStorage.getItem("ncmaandiCalculation")) : 1,
  
                  username: this.$route.query.username ? this.$route.query.username : "",
                  email: this.$route.query.email ? this.$route.query.email : "",
                  ipAddress: "",
                  deviceType: (window.innerWidth > 1205 ? 'BS' : 'SS'),
              },
              years: Array.from({ length: 401 }, (_, i) => 1800 + i),
              pdfUrl: "",
              horoscope: {},
              pageLoading: false,
              showOverlay: false,
              steps: [
                  { text: "Analyzing Ascendant Position... ", delay: 1 },
                  { text: "Analyzing Planetary Positions... ", delay: 1 },
                  { text: "Analyzing House Lord Positions... ", delay: 1 },
                  { text: "Finalizing Report...", delay: 1 }
              ],
              currentStep: 0,
              progressWidth: "0%",
              currentStatus: "Initializing..."

          };
      },
      created() {

          if (typeof this.$route.query.location === 'string' && this.$route.query.location.trim() !== '') {
            this.showChart();
          } else {
            // 'location' is missing or empty
          }

          // Clear the request query string parameters
          // We have captured query string values during during data intialization process
          // Now we do NOT need it again while coming back to this component
          this.$route.query = {};
  
      },
      mounted() {
        this.$nextTick(() => {
			    window.addEventListener('resize', this.onResize);
		      }
        )

        window.scrollTo(0, 0); // Instantly scroll to top when component is mounted

      },
      methods: {
          onResize() {
			      this.deviceType = (window.innerWidth > 1205 ? 'BS' : 'SS')
		      },

          isCriteriaSet: function () {
              return this.isValidLatitude() && this.isValidLongitude();
          },
          getUTCString: function () {
              return getUTCString(this.criteria.timeOffsetMinutes);
          },
          isValidLatitude: function () {
              return isValidLatitude(new String(this.criteria.latitude).trim());
          },
          isValidLongitude: function () {
              return isValidLongitude(new String(this.criteria.longitude).trim());
          },
          queryString: function (obj) {
              return queryString(obj);
          },
          getCriteriaToken: function() {
            return criteriaToken(this.criteria);
          },
          showChart: function () {
            this.criteria.chartStyle = this.userSelectedChartStyle;
            if (this.isCriteriaSet()) {
                this.getHoroscope();
            }
          },
          updatePdfUrl: function () {

                this.pdfUrl = ApiBaseUrl() + "/site/var/api/pdf/natalchart_basic?" + this.queryString(this.criteria) + "&ct=" + this.getCriteriaToken(this.criteria);

                // set new client info
                localStorage.setItem("ncwclient", this.criteria.client);

                // set new date & time in local storage
                localStorage.setItem("ncwyear", this.criteria.year);
                localStorage.setItem("ncwmonth", this.criteria.month);
                localStorage.setItem("ncwday", this.criteria.day);
                localStorage.setItem("ncwhour", this.criteria.hour);
                localStorage.setItem("ncwminute", this.criteria.minute);

                // keep new location info in local storage
                localStorage.setItem("ncwloc", this.criteria.location);
                localStorage.setItem("ncwlat", this.criteria.latitude);
                localStorage.setItem("ncwlong", this.criteria.longitude);
                localStorage.setItem("ncwtimeOffset", this.criteria.timeOffset);
                localStorage.setItem("ncwtimeOffsetMinutes", this.criteria.timeOffsetMinutes);
                localStorage.setItem("ncwtz", this.criteria.timezone);            
          },          

          viewChart: function() {
            this.updatePdfUrl();
            window.open(this.pdfUrl, "_blank");
          },

          updateCriteriaDate: function () {
              // Year value validation
              if (this.criteria.year) {
                  var selectedYear = Number.parseInt(this.criteria.year);
                  if (selectedYear < -12999 || selectedYear > 16799) {
                      window.alert("Unsupported year : " + selectedYear + ". Valid year range : 13000 BC - 16798 AD");
                      this.criteria.year = localStorage.getItem("ncyear") ? Number.parseInt(localStorage.getItem("ncyear")) : new Date().getFullYear();
                  }
              } else {
                  this.criteria.year = new Date().getFullYear();
              }
  
              // set selected date & time in local storage
              localStorage.setItem("ncyear", this.criteria.year);
              localStorage.setItem("ncmonth", this.criteria.month);
              localStorage.setItem("ncday", this.criteria.day);
              localStorage.setItem("nchour", this.criteria.hour);
              localStorage.setItem("ncminute", this.criteria.minute);
              localStorage.setItem("ncsecond", this.criteria.second);
  
              // Check for timeOffset Change
              this.checkTimeOffsetChangeForDate();
          },
          checkTimeOffsetChangeForDate: function() {
              HTTP().post(`/site/var/api/data/city/timeOffset?city=` + this.criteria.location + '&timezone=' + this.criteria.timezone
                          + '&year=' + this.criteria.year + '&month=' + this.criteria.month + '&day=' + this.criteria.day
                          + '&hour=' + this.criteria.hour + '&minute=' + this.criteria.minute + '&second=' + this.criteria.second)
              .then(response => {
                  var cityTimeOffset = response.data
                  // console.log('cityTimeOffset: ' + JSON.stringify(cityTimeOffset))
                  if ( cityTimeOffset ) {
                      this.criteria.timeOffset = cityTimeOffset
                      this.criteria.timeOffsetMinutes = cityTimeOffset * 60.0
                      localStorage.setItem("nctimeOffset", this.criteria.timeOffset);
                      localStorage.setItem("nctimeOffsetMinutes", this.criteria.timeOffsetMinutes);
                  }
              })
              .catch(e => {
                  console.log(e)
              })
          },
          setWorldCity: function (worldCity) {
              this.criteria.location = worldCity.city;
              this.criteria.latitude = worldCity.lat;
              this.criteria.longitude = worldCity.lng;
              this.criteria.timeOffset = worldCity.timeOffset;
              this.criteria.timeOffsetMinutes = worldCity.timeOffsetMinutes;
              this.criteria.timezone = worldCity.timezone;
  
              // keep this location info in local storage
              localStorage.setItem("ncloc", this.criteria.location);
              localStorage.setItem("nclat", this.criteria.latitude);
              localStorage.setItem("nclong", this.criteria.longitude);
              localStorage.setItem("nctimeOffset", this.criteria.timeOffset);
              localStorage.setItem("nctimeOffsetMinutes", this.criteria.timeOffsetMinutes);
              localStorage.setItem("nctz", this.criteria.timezone);
  
              // debug
              // console.log('cc:city: ' + this.criteria.location);
              // console.log('cc:lat: ' + this.criteria.latitude);
              // console.log('cc:lng: ' + this.criteria.longitude);
              // console.log('cc:timeOffset: ' + this.criteria.timeOffset);
              // console.log('cc:timeOffsetMinutes: ' + this.criteria.timeOffsetMinutes);
              // console.log('cc:timezone: ' + this.criteria.timezone);
          },

        getHoroscope: function() {
			this.pageLoading = true;
            this.startProgress();
			HTTP().post(`/site/var/api/data/horoscope?` + this.queryString(this.criteria))
			.then(response => {
				this.horoscope = response.data
                this.$emit("horoscope", this.horoscope);
				this.pageLoading = false
                this.completeProgress();
			})
			.catch(e => {
				console.log(e)
			})
		},
		startProgress() {
			this.showOverlay = true;
			this.currentStep = 0;
			this.updateStep(0);
    	},
		updateStep(index) {
			if (index < this.steps.length) {
				this.currentStatus = this.steps[index].text;
				this.progressWidth = `${((index + 1) / this.steps.length) * 100}%`;
				setTimeout(() => this.updateStep(index + 1), this.steps[index].delay * 1000);
			} else {
				setTimeout(() => this.completeProgress(), 1000);
			}
		},
		completeProgress() {
			this.showOverlay = false;
		}				
      },
      updated() {},
      beforeUnmount() {
          // Capture chart settings before leaving the component
          localStorage.setItem("ncclient", this.criteria.client);
          localStorage.setItem("ncyear", this.criteria.year);
          localStorage.setItem("ncmonth", this.criteria.month);
          localStorage.setItem("ncday", this.criteria.day);
          localStorage.setItem("nchour", this.criteria.hour);
          localStorage.setItem("ncminute", this.criteria.minute);
          localStorage.setItem("ncsecond", this.criteria.second);
          localStorage.setItem("ncloc", this.criteria.location);
          localStorage.setItem("nclat", this.criteria.latitude);
          localStorage.setItem("nclong", this.criteria.longitude);
          localStorage.setItem("nctimeOffsetMinutes", this.criteria.timeOffsetMinutes);
          localStorage.setItem("nctimeOffset", this.criteria.timeOffset);
          localStorage.setItem("nctz", this.criteria.timezone);
          localStorage.setItem("ncchartStyle", this.criteria.chartStyle);
          localStorage.setItem("ncayanamsa", this.criteria.ayanamsa);
          localStorage.setItem("ncbhavaChart", this.criteria.bhavaChartType);
          localStorage.setItem("ncddiy", this.criteria.dasaBuktiDaysInYear);
          localStorage.setItem("ncrkn", this.criteria.rahuNode);
          localStorage.setItem("nctopo", this.criteria.topocentricPlanets);
          localStorage.setItem("ncnutation", this.criteria.nutationRequired);
          localStorage.setItem("ncsunrise", this.criteria.hinduSunrise);
          localStorage.setItem("nccdl", this.criteria.conjunctionDegreeLimit);
          localStorage.setItem("ncadl", this.criteria.aspectDegreeLimit);
          localStorage.setItem("ncmaandiCalculation", this.criteria.maandiCalculationMethod);

          window.removeEventListener('resize', this.onResize);           
      },
  }
  </script>
  
  <style scoped>
  * {
    box-sizing: border-box;
  }
  body {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    background-color: #f8f8f8;
    color: #333;
  }
  .screen-center-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90vh;
    background-color: #f0f2f5;
    padding: 0 1rem; /* This adds breathing room on left & right */
    box-sizing: border-box;
  }  
  .form-container {
    background-color: #fff;
    padding: 2rem;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    max-width: 500px;
    width: 100%;
    min-width: 400px;
    margin: 0 auto;
  }
  .form-row {
    margin-bottom: 1.2rem;
  }
  label {
    display: block;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
  input[type="text"],
  select {
    width: 100%;
    padding: 0.6rem;
    border: 1px solid #ccc;
    border-radius: 8px;
    font-size: 1rem;
  }
  .dropdown-group {
    display: flex;
    gap: 0.5rem;
  }
  .dropdown-group select {
    flex: 1;
  }
  button {
    width: 100%;
    padding: 0.8rem;
    background-color: #344E41;
    color: #fff;
    font-size: 1.25rem;
    font-weight: bold;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  button:hover {
    background-color: #3a7bd5;
  }
  .logo {
    text-align: center;
    margin-bottom: 1rem;
  }
  .logo img {
    width: 297px;
    max-width: 100%;
  }

  @media (max-width: 500px) {

    .screen-center-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 130vh;
        background-color: #f0f2f5;
        padding: 0 1rem; /* This adds breathing room on left & right */
        box-sizing: border-box;
    }  

    .form-container {
      min-width: unset;
      padding: 1.2rem;
    }
    .dropdown-group {
      flex-direction: column;
    }
  }

  .overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  z-index: 500;
  padding: 20px;
  text-align: center;
}
.progress-container {
  width: 90%;
  max-width: 500px;
  background: #087F8C;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.2);
}
.progress-bar {
  width: 100%;
  background: #e7ece9;
  border-radius: 5px;
  overflow: hidden;
  margin-top: 10px;
}
.progress-fill {
  width: 0%;
  height: 20px;
  background: #1af721;
  transition: width 0.5s ease-in-out;
}
.status-text {
  margin-top: 10px;
  font-size: 18px;
}

@media (max-width: 600px) {
  .progress-container {
    width: 95%;
    padding: 15px;
  }
  .status-text {
    font-size: 16px;
  }
  .progress-fill {
    height: 25px;
  }
}

.main-title {
  font-size: 1.5rem;
  font-weight: 700;
  text-align: center;
  color: #087F8C;
  margin: 10px 0;
  line-height: 1.4;
  letter-spacing: 0.5px;
  padding-bottom: 25px;
}

/* Mobile responsiveness */
@media screen and (max-width: 480px) {
  .main-title {
    font-size: 1.6rem;
  }
}

  </style>
  